import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaSearch, FaFilter, FaTimes } from "react-icons/fa";

const ContractSearch = ({
  onSearch,
  onFilterByCategory,
  onFilterByStatus,
  contracts,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    const uniqueCategories = [
      ...new Set(contracts.map((contract) => contract.category)),
    ];
    setCategoryOptions(uniqueCategories);

    const uniqueStatuses = [
      ...new Set(contracts.map((contract) => contract.status)),
    ];
    setStatusOptions(uniqueStatuses);
  }, [contracts]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      onSearch(searchTerm);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, onSearch]);

  const handleCategoryFilterChange = (e) => {
    const category = e.target.value;
    setCategoryFilter(category);
    onFilterByCategory(category);
  };

  const handleStatusFilterChange = (e) => {
    const status = e.target.value;
    setStatusFilter(status);
    onFilterByStatus(status);
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  return (
    <div className="w-full">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex-grow flex items-center gap-2">
          <div className="relative flex-grow">
            <input
              type="text"
              placeholder="Search contracts..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent"
            />
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          </div>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={toggleFilters}
            className="p-2 bg-gray-700 text-white rounded-md shadow-md flex items-center justify-center flex-shrink-0"
          >
            {showFilters ? <FaTimes /> : <FaFilter />}
          </motion.button>
        </div>
        {showFilters && (
          <div className="w-full md:w-auto flex flex-col md:flex-row gap-2">
            <select
              value={categoryFilter}
              onChange={handleCategoryFilterChange}
              className="w-full md:w-auto px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent"
            >
              <option value="">Filter by Category</option>
              {categoryOptions.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
              ))}
            </select>
            <select
              value={statusFilter}
              onChange={handleStatusFilterChange}
              className="w-full md:w-auto px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent"
            >
              <option value="">Filter by Status</option>
              {statusOptions.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractSearch;